import { useMemo } from 'react'
import { initializeApollo } from '@website/lib/apolloClient'
import type { NormalizedCacheObject } from '@apollo/client'

export const useApolloClient = (initialState: NormalizedCacheObject = {}) => {
  return useMemo(() => initializeApollo(), [])
}
